<div class="measurements-modal">
  <div class="flex justify-center">
    @if (loading$ | async) {
    <fip-loading-spinner
      class="absolute left-2/4 top-2/4"
    ></fip-loading-spinner>
    } @else { @if (dataState === ComponentDataState.HasData) {
    <fip-table
      [data]="tableData"
      [columns]="columns"
      [displayedColumns]="displayedColumns"
      [paginated]="true"
      [pageSizeOptions]="[10, 25, 50]"
    ></fip-table>
    } @if (dataState === ComponentDataState.NoData) { No data available. } }
  </div>
</div>
